import { getProjects, ProjectsResponse } from "../api";
import { useQuery } from "react-query";

export function useProjects() {
  return useQuery<ProjectsResponse, Error>("projects", () => {
    return getProjects();
  });
}
